// src/pages/GanttPage.tsx
import { useParams, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import ModernGanttView from "../components/views/ModernGanttView";

export default function GanttPage() {
  const { projectId } = useParams();
  const [searchParams] = useSearchParams();
  const projectIdFromParams = projectId || searchParams.get('projectId');

  useEffect(() => {
    document.title = "TaskManager - Gantt";
  }, []);

  return (
    <ModernGanttView projectId={projectIdFromParams || undefined} />
  );
}